import axios from 'axios'

const path = 'api/objects'
export function GetObjects () {
  return axios.get(`${window.apiConfig.APIURL + path}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json; charset=UTF-8',
        Accept: 'application/json'
      },
      data: {
        Level: '0'
      }
    }
  )
}

export function GetObject (id) {
  return axios.get(`${window.apiConfig.APIURL + path}/${id}`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    })
}
